import { useLang } from "@/context/LanguageContext";
import api from "@/lib/api";
import { Languages } from "lucide-react";

/**
 * Small pill-style language toggle. Cycles through supported languages.
 * Used on Welcome and any other context where the user may want to change UI language.
 */
export default function LanguagePill({ persist = false, className = "" }) {
  const { lang, setLang } = useLang();

  const next = lang === "en" ? "hi" : "en";
  const label = lang === "en" ? "हिन्दी" : "English";

  const toggle = async () => {
    setLang(next);
    if (persist) {
      try { await api.put("/me/preferences", { language: next }); } catch {}
    }
  };

  return (
    <button
      onClick={toggle}
      data-testid="language-pill"
      aria-label={`Switch to ${label}`}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-caption tracking-wide transition-all active:scale-95 ${className}`}
      style={{
        backgroundColor: "rgba(184,149,74,0.08)",
        border: "1px solid rgba(184,149,74,0.3)",
        color: "var(--vedari-gold)",
      }}
    >
      <Languages size={13} strokeWidth={1.75} aria-hidden="true" />
      <span className="font-medium">{label}</span>
    </button>
  );
}
